__turbopack_context__.v({
  "accordions": "SeoContentAccordion-module-scss-module__7MW_Iq__accordions",
  "body": "SeoContentAccordion-module-scss-module__7MW_Iq__body",
  "container": "SeoContentAccordion-module-scss-module__7MW_Iq__container",
  "headerContent": "SeoContentAccordion-module-scss-module__7MW_Iq__headerContent",
  "heading": "SeoContentAccordion-module-scss-module__7MW_Iq__heading",
  "item": "SeoContentAccordion-module-scss-module__7MW_Iq__item",
});
